import checkout from "./form";

const {
  formField: {
    address,
    countryName,
    airlinesName,
    quarter,
    year,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    agencyName,
    agencyId,
    taxAgentContract,
    taxAgentContractDate,
    certificate,
    fullName,
    firstTime,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [address.name]: "",
  [countryName.name]: "",
  [airlinesName.name]: "",
  [quarter.name]: "",
  [year.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [agencyName.name]: "",
  [agencyId.name]: "",
  [taxAgentContractDate.name]: "",
  [taxAgentContract.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
